module.exports = __webpack_public_path__ + "static/media/groups.3b76c0f4.svg";